import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer style={{ background: "linear-gradient(135deg, #1a0a0f 0%, #2d0f1a 50%, #1a0a0f 100%)" }}>
      {/* Top accent line */}
      <div className="h-0.5 bg-gradient-to-r from-transparent via-pink-500 to-transparent" />

      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-8 md:mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3 md:mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/db459360-20e7-4f18-828f-b6f77daa6c55.png"
                alt="Girls' Map Logo"
                className="h-9 md:h-10 w-auto object-contain"
              />
              <span
                className="text-lg md:text-xl font-bold text-pink-400"
                style={{ fontFamily: "'Pacifico', cursive" }}
              >
                Girls&apos; Map
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-3 md:mb-4">
              GPSで今すぐ近くにいる女の子を発見。<br />
              登録不要・無料で使えるマッチングマップ。
            </p>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse flex-shrink-0"></span>
              <span className="text-green-400 text-xs font-medium">24時間稼働中</span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-bold text-sm mb-3 md:mb-4 tracking-wider uppercase">メニュー</h4>
            <div className="flex flex-col gap-2 md:gap-2.5">
              {[
                { label: "ホーム", path: "/", icon: "ri-home-4-line" },
                { label: "マップで探す", path: "/map", icon: "ri-map-pin-2-line" },
                { label: "女の子一覧", path: "/characters", icon: "ri-heart-3-line" },
              ].map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="flex items-center gap-2 text-gray-400 hover:text-pink-400 transition-colors text-sm cursor-pointer group"
                >
                  <i className={`${item.icon} text-pink-600 group-hover:text-pink-400 transition-colors`}></i>
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Features */}
          <div>
            <h4 className="text-white font-bold text-sm mb-3 md:mb-4 tracking-wider uppercase">特徴</h4>
            <div className="flex flex-col gap-2 md:gap-2.5">
              {[
                { icon: "ri-map-pin-2-fill", text: "GPS位置情報で近くの子を発見" },
                { icon: "ri-refresh-fill", text: "3時間ごとにリアルタイム更新" },
                { icon: "ri-user-heart-fill", text: "120人以上が登録中" },
                { icon: "ri-shield-check-fill", text: "安全・プライバシー保護" },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2 text-gray-400 text-sm">
                  <i className={`${item.icon} text-pink-600 text-xs flex-shrink-0`}></i>
                  {item.text}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-white/5 mb-5 md:mb-6" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4">
          <p className="text-gray-600 text-xs text-center sm:text-left">© 2026 Girls&apos; Map. All rights reserved.</p>
          <p className="text-gray-600 text-xs text-center sm:text-right">18歳未満の方のご利用はお断りしております</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
